import Link from 'next/link';
import * as React from 'react'
import UserPlanGuard from '../../../../auth/plans/UserPlanGuard';
import ActionButton from '../../../../general/ActionButton';
import FormatedNumber from '../../../../general/FormatedNumber';
import SatoshiToUsd from '../../../../general/SatoshiToUsd';
import TextContainer from '../../../../layout/TextContainer';
import CheckIcon from '@mui/icons-material/Check';
import env from '../../../../../lib/env';
import WhiteContainer from '../../../../layout/WhiteContainer';

type Props = {
  onClose?: () => any
}



const UserSubscriptionAd: React.FC<Props> = ({ onClose }) => {


  const lowestPrice = Math.min(...env.pricing.map(p => p.monthlyPriceSat));

  return (
    <React.Fragment>
      <div className="">

        <div className="flex justify-center px-2">


          <WhiteContainer className="px-8 pt-4 pb-6 bg-gradient-to-br from-white to-viking-500/80">

            <UserPlanGuard mustBe="ANONYMOUS">
              <h3 className="text-xl font-black">Start Free Trial</h3>
            </UserPlanGuard>

            <UserPlanGuard mustBe="AUTHENTICATED">
              <h3 className="text-xl font-black">Purchase Plan</h3>
            </UserPlanGuard>
            <p className="mb-8 text-gray-500">Get the most out of LnRouter and unlock important node metrics now.</p>


            <p className="text-xl font-bold "><FormatedNumber value={lowestPrice} />sat
              <span className="text-sm text-gray-500 font-normal"> = $<SatoshiToUsd satoshi={lowestPrice} /></span>
            </p>
            <p className="text-xs text-gray-500">per month</p>

            <table className="mt-6 text-sm font-light">
              <tbody>
                <tr>
                  <td>
                    <CheckIcon color="inherit" fontSize="inherit" className="text-viking-500 mr-2 text-base" />
                  </td>
                  <td>
                    Routing Score
                  </td>
                </tr>
                <tr>
                  <td>
                    <CheckIcon color="inherit" fontSize="inherit" className="text-viking-500 mr-2 text-base" />
                  </td>
                  <td>
                  Channel Recommender
                  </td>
                </tr>
                <tr>
                  <td>
                    <CheckIcon color="inherit" fontSize="inherit" className="text-viking-500 mr-2 text-base" />
                  </td>
                  <td>
                    HTLC Response Times
                  </td>
                </tr>
                <tr>
                  <td>
                    <CheckIcon color="inherit" fontSize="inherit" className="text-viking-500 mr-2 text-base" />
                  </td>
                  <td>
                    Detailed Test Data
                  </td>
                </tr>
                <tr>
                  <td>
                    <CheckIcon color="inherit" fontSize="inherit" className="text-viking-500 mr-2 text-base" />
                  </td>
                  <td>
                    Unlimited Access
                  </td>
                </tr>
              </tbody>
            </table>

            <div className="pt-8 text-center w-full mx-auto">
              <UserPlanGuard mustBe="ANONYMOUS">
                <Link href="/auth/login">
                  <a >
                    <ActionButton design='action' className="w-64">
                      Start free trial
                    </ActionButton>
                  </a>
                </Link>
              </UserPlanGuard>

              <UserPlanGuard mustBe="AUTHENTICATED">
                <Link href="/account/profile">
                  <a>
                    <ActionButton design='action' className=" w-64">
                      Purchase plan
                    </ActionButton>
                  </a>
                </Link>
              </UserPlanGuard>
              <div className="pt-1">
                <Link href="/">
                  <a>
                    <ActionButton design='secondary' className="w-64">
                      More info
                    </ActionButton>
                  </a>
                </Link>
              </div>
              {onClose &&
                <div className="pt-1">
                  <ActionButton
                    onClick={() => onClose()}
                    design='tertiary'
                    className="w-64">
                    Close
                  </ActionButton>
                </div>
              }

            </div>
          </ WhiteContainer>
        </div>

      </div>
    </React.Fragment>
  );
}

export default UserSubscriptionAd;

